import React from 'react';
import { useTranslation } from 'react-i18next';
import ServiceDetail from '../components/ServiceDetail';
import consultImage from '../assets/consult.png';
import './StrategicConsulting.css';

const StrategicConsulting = () => {
  const { t } = useTranslation();
  const serviceData = t('serviceContent.strategicConsulting', { returnObjects: true });

  return (
    <div className="strategic-consulting-page">
      <ServiceDetail serviceData={serviceData} serviceImage={consultImage} serviceKey="strategicConsulting" />
    </div>
  );
};

export default StrategicConsulting;



